<template>
    <div class="container">
      <v-card
        class="card"
        :style="{
          width: isMobile ? '100%' : '100%',
          padding: isMobile ? '10px' : '0px',
          height: isMobile ? '700px' : '500px',
          borderRadius: isMobile ? '0px' : '0px',
          marginTop: isMobile ? '0px' : '0px',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          color: 'white',
        }"
        style="
        background-color: #262626;
        "
        elevation="0"
      >
        <div class="image-section" style="flex: 1; display: flex; justify-content: center;">
          <img src="/images/ubuntu/Canonical-Devices-Ubuntu-Core.png" :width="isMobile ? '700' : '700'">
        </div>
  
        <!-- Text section (50% width) -->
        <div class="text-section" style="flex: 1;">
          <div
          :style="{
            fontSize: isMobile ? '30px' : '55px',
            fontWeight: isMobile ? '900' : '900',
          }">
            Canonical Ubuntu
          </div>
  
            <div
              :style="{
                fontSize: isMobile ? '15px' : '16px',
                fontWeight: isMobile ? '100' : '500',
              }"
            >
              Ubuntu Server는 데이터 센터나 공용 또는 사설 클라우드에서 경제적이고 기술적인 확장성을 제공합니다.
              <br>OpenStack 클라우드, Kubernetes 클러스터, 또는 대규모의 서버 집합을 구축할 때,
              <br>Ubuntu Server는 뛰어난 확장성과 성능을 보장합니다.
            </div><br>
            <div
              :style="{
                fontSize: isMobile ? '14px' : '16px',
                fontWeight: isMobile ? '100' : '300',
              }"
            >
              Ubuntu는 Canonical Limited의 상표이며
              <br>Canonical Limited의 허가를 받아 사용됩니다.
              <br>nn
              Ubuntu is a trademark of Canonical Limited and
              <br>is used with the permission of Canonical Limited.
            </div>
            
  
  
        </div>
      </v-card>
    </div>
  </template>
  
  <script>
  import { useRouter } from 'vue-router';
  import { ref, computed, onMounted } from 'vue';
  
  export default {
    setup() {
      const router = useRouter();
      const isMobile = ref(false);
  
      const checkIsMobile = () => {
        isMobile.value = window.innerWidth <= 768; // Check if the window width is less than or equal to 768px
      };
  
      const goToestimate = () => {
        router.push('/estimate');
      }
  
      onMounted(() => {
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
      });
  
      return {
        goToestimate,
        isMobile: computed(() => isMobile.value),
        isDesktop: computed(() => !isMobile.value),
      };
    },
  };
  </script>
  
  <style scoped>
  .container {
    display: flex;
    justify-content: center;
  }
  
  
  
  /* Styles for mobile */
  @media screen and (max-width: 768px) {
    .text-section {
      padding: 0px 20px 0 20px;
    }
  }
  </style>
  